import React from 'react';
import { WarningCircle, Info, XCircle } from '@phosphor-icons/react';

const AlertCard = ({ type, title, message, time, categoria, categoria_producto }) => {
  const colors = {
    danger: { bg: 'bg-[#ff5252]/10', border: 'border-[#ff5252]', text: 'text-[#ff5252]', icon: XCircle },
    warning: { bg: 'bg-[#ffc84a]/10', border: 'border-[#ffc84a]', text: 'text-[#ffc84a]', icon: WarningCircle },
    info: { bg: 'bg-[#4f9eff]/10', border: 'border-[#4f9eff]', text: 'text-[#4f9eff]', icon: Info },
  };

  const style = colors[type] || colors.info;
  const Icon = style.icon;

  return (
    <div className={`${style.bg} border-l-4 ${style.border} p-3 md:p-4 rounded-sm`} data-testid={`alert-${type}`}>
      <div className="flex items-start gap-2 md:gap-3">
        <Icon size={18} className={`${style.text} flex-shrink-0 mt-0.5`} weight="fill" />
        <div className="flex-1 min-w-0">
          <div className={`${style.text} font-['Mulish'] text-xs md:text-sm font-semibold mb-0.5 md:mb-1 truncate`}>{title}</div>
          <div className="text-[#8b949e] font-['Mulish'] text-[10px] md:text-xs truncate">{message}</div>
          {categoria_producto && (
            <div className="text-[#00d68f] font-['IBM_Plex_Mono'] text-[10px] md:text-xs mt-0.5 md:mt-1 uppercase">{categoria_producto}</div>
          )}
        </div>
        <div className="text-[#484f58] font-['IBM_Plex_Mono'] text-[10px] md:text-xs flex-shrink-0">{time}</div>
      </div>
    </div>
  );
};

export default AlertCard;